import React from "react";

export default function TermsConditions() {
    return (
        <div className="agreement mx-auto max-w-3xl p-6 leading-7 text-gray-800">
            <style>{`
        .agreement h1 { font-size: 1.75rem; font-weight: 700; margin: 1.25rem 0 .5rem; }
        .agreement h2 { font-size: 1.25rem; font-weight: 700; margin: 1rem 0 .25rem; }
        .agreement p { margin: .5rem 0; text-align: justify; }
        .agreement ul, .agreement ol { margin: .5rem 0 .75rem 1.25rem; }
        .agreement ol { list-style-type: decimal; padding-left: 1.5rem; }
        .agreement ul { list-style-type: disc; padding-left: 1.5rem; }
        .agreement li { text-align: justify; }
        /* Scroll constraint requested */
        .agreement { max-height: min(70vh, 480px); overflow-y: auto; }
        /* Stronger underline to beat resets/preflight */
        .agreement a, .agreement a:link, .agreement a:visited, .agreement a:hover, .agreement a:active {
          text-decoration-line: underline !important;
          text-decoration-thickness: from-font;
          text-underline-offset: 2px;
        }
        .agreement a *, .agreement u { text-decoration-line: underline !important; }
      `}</style>
            <p>
                <strong>TERMS AND CONDITION OF USE</strong>
            </p>
            <p>
                <em>These Terms of Use shall be accepted before using and/or accessing the application or site. Use of any part of the application or site constitutes acceptance of these Terms of Use.</em>
            </p>
            <p>
                The TruCarbon application and/or website accessible at{" "}
                <a href="https://trucarbon.co/" target="_blank" rel="noreferrer">
                    https://trucarbon.co
                </a>{" "}
                is managed by PT Solusi Transisi Iklim and its affiliated companies (collectively, “
                <strong>we</strong>
                ”, “
                <strong>our</strong>
                ” or “
                <strong>TruCarbon</strong>
                ”).
            </p>
            <p>
                By accessing and/or using any part of the application and/or website at{" "}
                <a href="https://trucarbon.co" target="_blank" rel="noreferrer">
                    https://trucarbon.co
                </a>, the User acknowledges that they have read, understood, and agreed to the terms and conditions set forth herein (“
                <strong>User Agreement</strong>
                ”), as well as to any other applicable terms referenced in this User Agreement.
            </p>
            <p>
                If the User does not agree to be bound by this User Agreement, the User may not access or use any part of TruCarbon. These terms constitute a binding legal agreement between the User and TruCarbon.
            </p>
            <p>
                <strong>DEFINITION</strong>
            </p>
            <ol>
                <li>
                    TruCarbon Site refers to the{" "}
                    <a href="https://trucarbon.co" target="_blank" rel="noreferrer">
                        https://trucarbon.co
                    </a>
                    , as well as any other website owned or shall be owned by TruCarbon, including under other domains or sub-domains that shall be developed and operated by TruCarbon in the future.
                </li>
                <li>
                    TruCarbon Application is an application named
                    “TruCarbon”
                    or under any other name which is owned or shall be owned by TruCarbon, which can be downloaded on the Google Play Store and/or App Store, managed by PT Solusi Transisi Iklim and its affiliated company.
                </li>
                <li>
                    Platform refers to TruCarbon Application and/or TruCarbon Site, including any versions thereof developed and/or operated by TruCarbon, whether now or in the future.
                </li>
                <li>
                    The Users are parties in the form of individuals, business entities and/or project developers who use the TruCarbon Site and/or TruCarbon Application, engaging TruCarbon for its services.
                </li>
                <li>
                    Services are provided by TruCarbon on the TruCarbon Site and/or TruCarbon Application.
                </li>
                <li>
                    Partner refers to the Project proponent partner selected by TruCarbon to be matched to the User in connection with     the Services conducted in the Platform, with the capability to collaborate in the co-development of the Project. Such collaboration shall be established under a distinct and definitive agreement to be entered into between the User, TruCarbon and/or the Partner.
                </li>
                <li>
                    MOEF Reg refers to the Regulation of the Minister of Environment and Forestry regarding the implementation of carbon trading, including but not limited to MOEF Regulation No. 21 of 2022 on Procedure for Implementation of Carbon Pricing and its amendments (if any).
                </li>
                <li>
                    The National Registry System for Climate Change Control (hereinafter referred to as “SRN-PPI”) is a web-based data and information management and provision system on actions and resources for climate change adaptation and mitigation in Indonesia.
                </li>
                <li>
                    GRI is the Global Reporting Initiative.
                </li>
                <li>
                    GRI Standard is the GRI Sustainability Reporting Standards issued by the Global Sustainability Standards Board (GSSB).
                </li>
            </ol>
            <p>
                <strong>USER ACCOUNT</strong>
            </p>
            <ol>
                <li>
                    The User hereby declares that the User is a competent entity and is able to bind himself in a legal agreement according to Indonesian law. In this case, the User has also obtained any internal approval (if any) to enter into the Agreement and/or use the Platform (if necessary).
                </li>
                <li>
                    Unless it relates to the provided Service and/or is stipulated otherwise in the User Agreement or another agreement, TruCarbon does not charge a registration fee to the User.
                </li>
                <li>
                    The User understands that one mobile phone number and one email address can only be used to register one TruCarbon User account. However, an entity or company may have multiple User accounts (main account and additional accounts) by registering each account with a different email address and phone number.
                </li>
                <li>
                    The User shall create an account to use the Platform. We will collect and process the User's personal data, such as name, email address, and telephone number, when the User registers to create an account. The User shall provide us with current, complete, and accurate information and agrees to provide any evidence or identity we may require. We will collect and use such data solely for administrative purposes and shall not disclose the User’s personal data, in accordance with our Privacy Policy, available{" "}
                    <a href="https://account.trucarbon.co/assets/documents/privacy-policy.pdf" target="_blank" rel="noreferrer">
                        here
                    </a>
                    .
                </li>
                <li>
                    Only the User can use the User's own account, and the User represents and warrants that the User shall not allow any other party to use the User's identity or account for any reason unless permitted by TruCarbon.
                </li>
                <li>
                    The User shall maintain the security and confidentiality of User account passwords and any identification we provide to the User. In the event of disclosure of the User's password, in any way that results in unauthorized use of User's account or identity, any action taken using the account will still be considered valid. Subject to the rights that the User may have legally, the User hereby declares that TruCarbon is not responsible for any loss arising from the misuse of the User's account in accordance with this clause.
                </li>
                <li>
                    TruCarbon has the irrevocable prerogative right to temporarily block, delete, or deactivate a User's account without giving a reason to the User. Reasons for temporarily blocking, deleting, or deactivating a User's account include but are not limited to:
                </li>
                <li>
                    Violating this User Agreement;
                </li>
                <li>
                    Performing criminal activities; and/or
                </li>
                <li>
                    Conduct any suspicious activity.
                </li>
                <li>
                    The User hereby declares that TruCarbon shall not be responsible for any losses or problems arising from the misuse of the User account caused by the User's negligence, including but not limited to providing the login access of the account provided by TruCarbon via messages notification to other parties via the User’s device, lending the account to another party, or the negligence of the User which causing losses or problems in the User's account.
                </li>
            </ol>
            <p>
                <strong>SCOPE OF SERVICES</strong>
            </p>
            <p>
                Through this Platform, we provide an online      platform, so the Users are able to browse and use any various service types that we provide in the forestry, environmental and other related sectors (“
                <strong>Services</strong>
                ”). In this context, Services include:
            </p>
            <ol>
                <li>
                    <strong>TruCount</strong>
                    : the first and only Indonesian Official Software &amp; Tools Partner of GRI Standards, referring to any services provided on the Platform for greenhouse gas (“GHG”) emission accounting software that may be used by Users (companies) to record, monitor, and generate emission reports based on generally acknowledged international and local
                    standards. This Platform will provide expert guidance, emission accounting, and reporting consultations. This Platform can also provide data-driven solutions based on a feasibility matrix tailored to the User’s needs, and the User can track and manage goals for their decarbonization strategies.
                </li>
            </ol>
            <p>
                We can modify, remove and/or add services on this Platform per our internal policies and changes in applicable laws and regulations.
            </p>
            <p>
                The arrangement of the Services on the Platform shall be governed by a separate and definitive technical service agreement between the User and TruCarbon.
            </p>
            <p>
                <strong>TRUCOUNT</strong>
            </p>
            <ol>
                <li>
                    As a provider of services to record, monitor, and generate all emissions reports in a single Platform, the Platform (TruCount) calculates and analyzes emissions in accordance with internationally and locally acknowledged standards for the User.
                </li>
                <li>
                    Planning and reporting documents are to be prepared internally by the business actor and subsequently validated and verified by accredited validators and verifiers in accordance with the MOEF Regulation.
                </li>
                <li>
                    Data from the Platform (TruCount), including the business actor’s emission baseline calculations and periodic analysis of actual GHG emissions or absorption, may support the User’s compliance with their planning and reporting obligations.
                </li>
            </ol>
            <p>
                <strong>GRI STANDARD</strong>
            </p>
            <p>
                The GRI Standards are used by TruCarbon under licensed authority from GRI. GRI, as licensor of the copyright in the GRI Standards, verified and validated the authentic and accurate representation of the GRI Standards in TruCarbon Services. This verification was limited to ensuring the maintenance of the integrity, authenticity and accuracy of the TruCarbon Services. GRI therefore makes no implied or actual representations or warranties as to the correctness, compliance, trustworthiness, fitness of purpose or quality of TruCarbon Services or any products resulting therefrom; or of TruCarbon's use of the GRI copyrighted content; and expressly disclaims any implied or express representations that any report produced by TruCarbon meets the standards of an approved GRI standards report.
            </p>
            <p>
                <strong>TRANSACTION</strong>
            </p>
            <ol>
                <li>
                    The User are required to transact through the transaction procedures set by TruCarbon.
                </li>
                <li>
                    The User fully understands and agrees that all transactions made by the User, other than the procedures that have been set, are the responsibility of the User.
                </li>
                <li>
                    The User is highly recommended to keep the proof of payment provided for any transactions made in relations to the Platform.
                </li>
                <li>
                    The User understands and agrees that the problem of delays in the payment process and additional costs caused by differences in the bank that the User uses with the TruCarbon Authorized Bank Account is the User's personal responsibility.
                </li>
            </ol>
            <p>
                <strong>PAYMENT PROCEDURE</strong>
            </p>
            <ol>
                <li>
                    All payments are made in Rupiah value and currency.
                </li>
                <li>
                    TruCarbon may collect taxes or levies (if necessary or regulated by applicable law and regulation). However, if TruCarbon does not determine or instruct, the User (or other parties, if any) will bear their own tax and retribution payments by themselves.
                </li>
                <li>
                    For all forms of transaction, the User shall make payment within the specified time limit. TruCarbon reserves the right to cancel the transaction(s) if payment is not made. In such case, the User shall have no right to make any claims.
                </li>
                <li>
                    Payment methods include but are not limited to bank transfer, and other payment methods available on TruCarbon (including any third party payment method that under cooperation with TruCarbon).
                </li>
            </ol>
            <p>
                For payments made via bank transfer, the User must provide a bank transfer receipt as proof of payment for the reservation listed in the TruCarbon confirmation email. The User must also follow the procedures stated in the confirmation email.
            </p>
            <p>
                <strong>SERVICES COST</strong>
            </p>
            <ol>
                <li>
                    The Services cost contained in the Platform is the price set by TruCarbon and/or Partner.
                </li>
                <li>
                    The User understands and agrees that any problems and/or disputes that occur due to disagreements between the Partner and the User regarding the price are not the responsibility of TruCarbon.
                </li>
                <li>
                    By conducting a transaction through the Platform, the User agrees to pay the total cost to be paid as stated on the payment page.
                </li>
            </ol>
            <p>
                <strong>CANCELLATION</strong>
                <strong> </strong>
                <strong>AND REFUND</strong>
            </p>
            <ol>
                <li>
                    The User may only cancel any transactions made on the Platform based on the discretion and policies of TruCarbon and/or Partner.
                </li>
                <li>
                    In connection with a user cancellation that has been made, TruCarbon may be able to withhold or take part of the amount paid to reimburse costs that have been incurred in connection with the cancellation. Refund will be carried out based on TruCarbon discretion, and the User understands on that policy.
                </li>
            </ol>
            <p>
                <strong>USER RIGHTS</strong>
            </p>
            <p>
                TruCarbon grants the User a personal, worldwide, royalty-free, non-transferable, non-exclusive, revocable, and non-sublicensable license to access and use the Services. This license is for the sole purpose of enabling the User to use and enjoy the benefits of this Service as intended by TruCarbon and permitted by this User Agreement. Therefore, the User agrees not to:
            </p>
            <ol>
                <li>
                    use the service or any content contained in the Service for any commercial purposes without our express written consent.
                </li>
                <li>
                    copy, modify, transmit, create derivative works, utilize, or reproduce materials, images, trademarks, trade names, copyrighted service marks, or other intellectual property, content, or patent information that can be accessed through the Services without TruCarbon's prior written consent.
                </li>
                <li>
                    represent or imply that any statements User makes are endorsed by TruCarbon.
                </li>
                <li>
                    use robots, bots (automated programs), spiders (Site searchers), crawlers (web crawlers), scrapers (data collectors), site search/retrieval applications, proxies, or any other manual or automated device, method or process to access, retrieve, index, “data mining”, or reproduce, circumvent the navigation structure or appearance of the Service or its content in any way.
                </li>
                <li>
                    use the Service in any way that may hinder, interfere with, or have a negative impact on the service, servers, or networks connected to the Service.
                </li>
                <li>
                    upload viruses or other malicious code or compromise the security of the Service.
                </li>
                <li>
                    falsify or manipulate identifiers to disguise the origin of information transmitted to or through the Service.
                </li>
                <li>
                    “plagiarize” or “copy” any part of the Service without TruCarbon's prior written permission.
                </li>
                <li>
                    check, scan, or test for vulnerabilities of our Service or any system or network.
                </li>
                <li>
                    encourage or support any activity that violates this User Agreement.
                </li>
            </ol>
            <p>
                <strong>INTELLECTUAL PROPERTY RIGHTS</strong>
            </p>
            <ol>
                <li>
                    We are the licensee and/or holder of the rights to the names, icons, logos, and trademarks of ‘
                    <strong>TRUCARBON’</strong>
                    ,
                    ‘
                    <strong>TRUCOUNT</strong>
                    <strong>’</strong>
                    , and any other brands, platforms, or marks developed or operated under TruCarbon, which are protected under the applicable intellectual property laws of the Republic of Indonesia. The User may not use, reproduce, modify, or install any part of these names, icons, logos, or brands without our prior written consent.
                </li>
                <li>
                    We reserve the right to take legal action against any unauthorized use or other violations of our intellectual property rights related to the Application, the Platform (TruCount), or any services and/or brands developed or affiliated with TruCarbon.
                </li>
            </ol>
            <p>
                <strong>OTHER PROVISIONS</strong>
            </p>
            <ol>
                <li>
                    If the User uses the features available in the Platform, the User hereby declares that he understands and agrees to all the terms and conditions that are specifically regulated.
                </li>
                <li>
                    Everything that has not been and/or is not regulated in the User Agreement will fully refer to the user agreement in general.
                </li>
            </ol>
            <p>
                <strong>USER REPRESENTATION AND WARRANTIES</strong>
            </p>
            <p>
                User represents and warrants to TruCarbon that it is (i) legally competent to enter into the Agreement and use the Platform; (ii) has obtained approval (both internal and external) to enter into the Agreement and use the Platform (if any); and (iii) is not prohibited or contradicted by other agreements between the User and other parties.
            </p>
            <p>
                <strong>DISCLAIMER OF WARRANTIES AND LIMITATIONS OF LIABILITY</strong>
            </p>
            <ol>
                <li>
                    TruCarbon always strives to keep the Platform’s services safe, convenient, and functioning properly, but we cannot guarantee continuous operation or perfect access to our services. Information and data in the Platform may not occur in real-time.
                </li>
                <li>
                    The User agrees that the User uses the TruCarbon service at the User's risk and the TruCarbon service is provided to the User on an “as is” and “as available” basis.
                </li>
                <li>
                    To the extent permitted by applicable law, TruCarbon shall not be responsible, and the User agrees not to claim TruCarbon for any damage or loss resulting directly or indirectly from:
                </li>
                <li>
                    User's use or inability to use Services.
                </li>
                <li>
                    Prices, shipping, or other instructions available in the Services.
                </li>
                <li>
                    Delays or interruptions in Services.
                </li>
                <li>
                    Negligence caused by the User.
                </li>
                <li>
                    Disputes between User.
                </li>
                <li>
                    Infringement of Intellectual Property Rights.
                </li>
                <li>
                    Defamation.
                </li>
                <li>
                    Losses due to payment outside the method specified by TruCarbon.
                </li>
                <li>
                    Virus or other malicious software obtained by accessing or connecting to Services.
                </li>
                <li>
                    Any interruptions, bugs, errors, or inaccuracies in the Services.
                </li>
                <li>
                    There are hacking actions carried out by third parties to User accounts.
                </li>
            </ol>
            <p>
                <strong>COMPENSATION</strong>
            </p>
            <p>
                The User shall indemnify and hold harmless TruCarbon against any claims and demands, including reasonable legal fees, made by third parties arising out of the User’s violation of the provisions in this User Agreement or improper use of TruCarbon's services.
            </p>
            <p>
                <strong>SEVERABILITY</strong>
            </p>
            <p>
                Each provision of this User Agreement is severable from the others, and if any provision is held to be invalid or unenforceable, the remaining provisions will remain in full force and effect. TruCarbon has the right to change any provisions of this User Agreement that violate or conflict with laws and regulations (both existing and future) to adjust them in line with these laws and regulations without eliminating the validity of this User Agreement.
            </p>
            <p>
                <strong>UPDATE</strong>
            </p>
            <p>
                This User Agreement may be changed and/or updated from time to time without prior notice. TruCarbon recommends that the User read carefully and check this User Agreement page from time to time for any changes. By continuing to access the TruCarbon service, the User is deemed to have agreed to changes in the User Agreement.
            </p>
            <p>
                <strong>CHOICE OF LAW AND CHOICE OF FORUM</strong>
            </p>
            <p>
                This User Agreement is governed and made under the laws of the Republic of Indonesia. The user agrees that if a dispute arises over this User Agreement or as a result of our services, the dispute resolution is carried out by deliberation and consensus. If it cannot be resolved, the dispute can be resolved through the Badan Arbitrase Nasional Indonesia (BANI) address in Wahana Graha Lt. 1&amp;2, Jalan Mampang Prapatan No. 2, Duren Tiga, Pancoran, RT.4/RW.1, Duren Tiga, Kec. Pancoran, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12760; in accordance with applicable provisions regarding dispute resolution through arbitration in Indonesia.
            </p>
            <p>
                <strong>FORCE MAJEURE</strong>
            </p>
            <p>
                TruCarbon is not responsible for any violation of this User Agreement in relation to unexpected system damage. Force majeure includes but is not limited to natural disasters (floods, earthquakes, fires), terrorism, pandemic, epidemic, embargoes, changes in laws and regulations, and cyber-attacks.
            </p>
            <p>
                <strong>ENTIRE AGREEMENT</strong>
            </p>
            <p>
                This User Agreement constitutes the entire agreement between the User and TruCarbon with respect to the subject matter of this User Agreement. All prior agreements or arrangements, written or oral, between the User and TruCarbon relating to the subject matter are hereby superseded by this User Agreement.
            </p>
            <p>
                <strong>GENERAL</strong>
            </p>
            <ol>
                <li>
                    This User Agreement will govern the entire agreement and understanding between the User and TruCarbon on the subject matter thereof and will supersede all prior agreements, whether written or oral, between the User and TruCarbon regarding the subject matter
                    thereof. If necessary, TruCarbon and Users (as well as other party, if relevant) may sign a separate agreement, as an implementation of the Service(s) providence to the Users.
                </li>
                <li>
                    TruCarbon, and Users (as well as other party, if any) agree to waive the provisions of Articles 1266 and 1267 of the Civil Code to the extent that these Articles require court approval for the termination of this User Agreement.
                </li>
                <li>
                    For the avoidance of doubt, TruCarbon does not manage or control the Partner.
                </li>
                <li>
                    This User Agreement is made in Indonesian and English and is in accordance with the statutory provisions regarding the use of the Indonesian language. In the event that there is a difference in translation, the Indonesian version will prevail, and the English version must be adapted to the Indonesian version. Furthermore, the Users also agree that they will not file any claims or lawsuits against TruCarbon regarding the use of language in this User Agreement.
                </li>
                <li>
                    If any provision is determined to be unenforceable or invalid, by a court of competent jurisdiction, that provision will remain in force to the fullest extent permitted by applicable law and such provision shall not affect the validity and enforceability of any other remaining provisions. Disconnected provisions should be replaced with provisions that are as close to the original wording and intent as possible.
                </li>
                <li>
                    The failure of either Party to enforce any provision of these Terms at any time shall not be construed as a waiver of the respective Party's right to enforce its breach of such provision or any other provision of these Terms or as a waiver of its continued breach, following or following any other terms or conditions of this User Agreement.
                </li>
                <li>
                    The User may not assign or transfer the User’s rights or obligations under these Terms without TruCarbon’s prior written consent.
                </li>
                <li>
                    This User Agreement and Privacy Policy (
                    <a href="https://account.trucarbon.co/assets/documents/privacy-policy.pdf" target="_blank" rel="noreferrer">
                        available here
                    </a>
                    ) are an integral part that must be mutually agreed upon by the User before using the Platform.
                </li>
            </ol>
            <p>
                <strong>FAQs</strong>
            </p>
            <p>
                If there are any questions, please refer to the{" "}
                <a href="https://trucarbon.co/contact-us" target="_blank" rel="noreferrer">
                    FAQs
                </a>
                .
            </p>
            <p>
                Or contact us through our email{" "}
                <a href="mailto:contact@trucarbon.co" target="_blank" rel="noreferrer">
                    contact@trucarbon.co
                </a>
            </p>
            <p>
                <strong>SYARAT DAN KETENTUAN PENGGUNAAN</strong>
            </p>
            <p>
                <em>Ketentuan Penggunaan ini harus disetujui terlebih dahulu sebelum menggunakan dan/atau mengakses aplikasi atau situs. Penggunaan sebagian atau seluruh bagian dari aplikasi atau situs dianggap sebagai persetujuan terhadap Ketentuan Penggunaan ini.</em>
            </p>
            <p>
                Aplikasi dan/atau situs web TruCarbon yang dapat diakses melalui{" "}
                <a href="https://trucarbon.co" target="_blank" rel="noreferrer">
                    https://trucarbon.co
                </a>{" "}
                dikelola oleh PT Solusi Transisi Iklim dan perusahaan afiliasinya (secara bersama-sama disebut “
                <strong>kami</strong>
                ”, “
                <strong>milik kami</strong>
                ” atau “
                <strong>TruCarbon</strong>
                ”).
            </p>
            <p>
                Dengan mengakses dan/atau menggunakan sebagian atau seluruh bagian dari aplikasi dan/atau situs web di{" "}
                <a href="https://trucarbon.co" target="_blank" rel="noreferrer">
                    https://trucarbon.co
                </a>{" "}
                , Pengguna menyatakan bahwa Pengguna telah membaca, memahami, dan menyetujui syarat dan ketentuan yang tercantum di sini (“
                <strong>Ketentuan Pengguna</strong>
                ”), serta ketentuan lain yang berlaku sebagaimana dirujuk dalam Ketentuan Pengguna ini.
            </p>
            <p>
                Jika Pengguna tidak menyetujui untuk terikat oleh Ketentuan Pengguna ini, maka Pengguna tidak diperkenankan untuk mengakses atau menggunakan bagian apa pun dari TruCarbon. Ketentuan ini merupakan perjanjian hukum yang mengikat antara Pengguna dan TruCarbon.
            </p>
            <p>
                <strong>DEFINISI</strong>
            </p>
            <ol>
                <li>
                    Situs TruCarbon merujuk pada{" "}
                    <a href="https://trucarbon.co" target="_blank" rel="noreferrer">
                        https://trucarbon.co
                    </a>{" "}
                    , serta situs web lain yang dimiliki atau akan dimiliki oleh TruCarbon, termasuk yang menggunakan domain atau sub-domain lain yang akan dikembangkan dan dioperasikan oleh TruCarbon di kemudian hari.
                </li>
                <li>
                    Aplikasi TruCarbon adalah aplikasi bernama
                    “
                    TruCarbon
                    ”
                    atau dengan nama lain yang dimiliki atau akan dimiliki oleh TruCarbon, yang dapat diunduh melalui Google Play Store dan/atau App Store, dikelola oleh PT Solusi Transisi Iklim dan perusahaan-perusahaan afiliasinya.
                </li>
                <li>
                    Platform merujuk pada Aplikasi TruCarbon dan/atau Situs TruCarbon, termasuk versi yang dikembangkan dan/atau dioperasikan oleh TruCarbon, baik yang tersedia saat ini maupun di masa depan.
                </li>
                <li>
                    Pengguna adalah pihak dalam bentuk individu, badan usaha dan/atau pengembang proyek yang menggunakan Situs TruCarbon dan/atau Aplikasi TruCarbon, yang melibatkan TruCarbon untuk layanannya.
                </li>
                <li>
                    Layanan disediakan oleh TruCarbon di Situs TruCarbon dan/atau Aplikasi TruCarbon.
                </li>
                <li>
                    Mitra mengacu pada mitra pengembang Proyek yang dipilih oleh TruCarbon untuk dipasangkan dengan Pengguna sehubungan dengan      Layanan yang dilakukan di Platform, yang memiliki kemampuan untuk berkolaborasi dalam pengembangan bersama Proyek. Kolaborasi tersebut akan dituangkan dalam suatu perjanjian tersendiri dan definitive yang akan dibuat antara Pengguna, TruCarbon dan/atau Mitra.
                </li>
                <li>
                    Peraturan KLHK mengacu pada Peraturan Menteri Lingkungan Hidup dan Kehutanan mengenai pelaksanaan perdagangan karbon, termasuk namun tidak terbatas pada Peraturan Menteri LHK No. 21 Tahun 2022 tentang Tata Laksana Penerapan Nilai Ekonomi Karbon dan perubahannya (jika ada).
                </li>
                <li>
                    Sistem Registri Nasional Pengendalian Perubahan Iklim (selanjutnya disebut “SRN-PPI”) adalah sistem pengelolaan dan penyediaan data dan informasi berbasis web tentang tindakan dan sumber daya untuk adaptasi dan mitigasi perubahan iklim di Indonesia.
                </li>
                <li>
                    GRI adalah Global Reporting Initiative.
                </li>
                <li>
                    Standar GRI adalah Standar Pelaporan Keberlanjutan GRI yang diterbitkan oleh Global Sustainability Standards Board (GSSB).
                </li>
            </ol>
            <p>
                <strong>AKUN PENGGUNA</strong>
            </p>
            <ol>
                <li>
                    Pengguna dengan ini menyatakan bahwa Pengguna adalah entitas yang cakap dan mampu mengikatkan diri dalam sebuah perjanjian yang sah menurut hukum Republik Indonesia. Dalam hal ini, Pengguna juga telah memperoleh setiap persetujuan internal (apabila ada) untuk mengikatkan diri dalam Perjanjian dan/atau menggunakan Platform (apabila diperlukan).
                </li>
                <li>
                    Kecuali berkaitan dengan Layanan yang diberikan dan/atau ditentukan lain dalam Ketentuan Pengguna atau perjanjian lainnya, TruCarbon tidak mengenakan biaya pendaftaran kepada Pengguna.
                </li>
                <li>
                    Pengguna memahami bahwa satu nomor ponsel dan satu alamat email hanya dapat digunakan untuk mendaftarkan satu akun Pengguna TruCarbon. Namun, suatu entitas atau perusahaan dapat memiliki beberapa akun Pengguna (akun utama dan akun tambahan) dengan mendaftarkan masing-masing akun menggunakan alamat email dan nomor ponsel yang berbeda.
                </li>
                <li>
                    Pengguna harus membuat akun untuk dapat menggunakan Platform. Kami akan mengumpulkan dan memproses data pribadi Pengguna, seperti nama, alamat email, dan nomor telepon, pada saat Pengguna mendaftar untuk membuat akun. Pengguna wajib memberikan informasi yang akurat, lengkap dan terbaru, serta setuju untuk memberikan bukti atau identitas yang mungkin diperlukan. Kami hanya akan mengumpulkan dan menggunakan data tersebut untuk keperluan administrasi dan tidak akan mengungkapkan data pribadi Pengguna,s esuai dengan Kebijakan Privasi kami yang tersedia{" "}
                    <a href="https://account.trucarbon.co/assets/documents/privacy-policy.pdf" target="_blank" rel="noreferrer">
                        disini
                    </a>
                    .
                </li>
                <li>
                    Hanya Pengguna yang dapat menggunakan akun Pengguna sendiri dan Pengguna menyatakan dan menjamin bahwa Pengguna tidak akan mengizinkan pihak lain mana pun untuk menggunakan identitas atau akun Pengguna dengan alasan apa pun, kecuali diizinkan oleh TruCarbon.
                </li>
                <li>
                    Pengguna harus menjaga keamanan dan kerahasiaan kata sandi akun Pengguna dan setiap identifikasi yang kami berikan kepada Pengguna. Dalam hal pengungkapan kata sandi Pengguna, dengan cara apa pun yang mengakibatkan penggunaan akun atau identitas Pengguna secara tidak sah, segala tindakan dari penggunaan yang tidak sah tersebut akan tetap diproses. Tunduk pada hak yang mungkin Pengguna miliki secara hukum, Pengguna dengan ini menyatakan bahwa TruCarbon tidak bertanggung jawab atas segala kerugian yang timbul dari penyalahgunaan akun Pengguna sesuai dengan klausul ini.
                </li>
                <li>
                    TruCarbon memiliki hak prerogatif yang tidak dapat dicabut untuk melakukan pemblokiran sementara, penghapusan, atau menon-aktifkan akun Pengguna tanpa harus memberikan alasan kepada Pengguna. Alasan untuk melakukan pemblokiran sementara, penghapusan, atau menon-aktifkan akun Pengguna adalah termasuk namun tidak terbatas pada:
                </li>
                <li>
                    Melakukan pelanggaran atas Ketentuan Pengguna;
                </li>
                <li>
                    Melakukan aktivitas kriminal; dan/atau
                </li>
                <li>
                    Melakukan aktivitas mencurigakan.
                </li>
                <li>
                    Pengguna dengan ini menyatakan bahwa TruCarbon tidak akan bertanggung jawab atas kerugian ataupun kendala yang timbul atas penyalahgunaan akun Pengguna yang diakibatkan oleh kelalaian Pengguna, termasuk namun tidak terbatas pada memberikan akses masuk akun yang dikirimkan oleh TruCarbon melalui pesan kepada pihak lain melalui
                    perangkat Pengguna, meminjamkan akun kepada pihak lain, maupun kelalaian Pengguna lainnya yang mengakibatkan kerugian ataupun kendala pada akun Pengguna.
                </li>
            </ol>
            <p>
                <strong>RUANG LINGKUP LAYANAN</strong>
            </p>
            <p>
                Melalui Platform ini, kami menyediakan platform Online sehingga Pengguna dapat menelusuri dan menggunakan berbagai jenis layanan yang kami sediakan pada sektor kehutanan, lingkungan hidup, dan sektor terkait lainnya (“
                <strong>Layanan</strong>
                ”). Pada konteks ini, Layanan mencakup:
            </p>
            <ol>
                <li>
                    <strong>TruCount</strong>
                    : merupakan Software &amp; Tools Partner pertama dan satu-satunya di Indonesia yang diakui secara resmi oleh Standar GRI. yang merujuk pada layanan apa pun yang disediakan melalui Platform untuk perangkat lunak akuntansi emisi gas rumah kaca (“GRK”) yang dapat digunakan oleh Pengguna (perusahaan) untuk mencatat, memantau, dan menghasilkan laporan emisi berdasarkan standar internasional dan lokal yang diakui secara umum. Platform ini akan menyediakan panduan dari para ahli, layanan akuntansi emisi, dan konsultasi pelaporan. Platform ini juga dapat menyediakan solusi berbasis data berdasarkan matriks kelayakan yang disesuaikan dengan kebutuhan Pengguna, serta memungkinkan Pengguna untuk melacak dan mengelola target dalam strategi dekarbonisasi mereka.
                </li>
            </ol>
            <p>
                Kami dapat mengubah, menghapus, dan/atau menambahkan layanan-layanan dalam Platform ini sesuai dengan kebijakan internal kami, maupun perubahan dalam peraturan perundang-undangan yang berlaku.
            </p>
            <p>
                Pengaturan Layanan pada Platform akan diatur dalam perjanjian layanan teknis yang terpisah dan definitif antara Pengguna dan TruCarbon.
            </p>
            <p>
                <strong>TRUCOUNT</strong>
            </p>
            <ol>
                <li>
                    Sebagai penyedia layanan untuk mencatat, memantau, dan menghasilkan seluruh laporan emisi dalam satu Platform, Platform (TruCount) melakukan perhitungan dan analisis emisi sesuai dengan standar yang diakui secara internasional dan lokal untuk Pengguna.
                </li>
                <li>
                    Dokumen perencanaan dan pelaporan disusun secara internal oleh pelaku usaha dan selanjutnya divalidasi serta diverifikasi oleh validator dan verifikator terakreditasi sesuai dengan Peraturan KLHK.
                </li>
                <li>
                    Data dari Platform (TruCount), termasuk perhitungan baseline emisi pelaku usaha dan analisis berkala atas emisi atau serapan GRK aktual, dapat mendukung kepatuhan Pengguna terhadap kewajiban perencanaan dan pelaporan mereka.
                </li>
            </ol>
            <p>
                <strong>STANDAR GRI</strong>
            </p>
            <p>
                Standar GRI digunakan oleh TruCarbon di bawah otoritas berlisensi dari GRI. GRI, sebagai pemberi lisensi hak cipta dalam Standar GRI, memverifikasi dan memvalidasi representasi Standar GRI dalam Layanan TruCarbon yang autentik dan akurat. Verifikasi ini terbatas untuk memastikan terpeliharanya integritas, keaslian dan keakuratan Layanan TruCarbon. Oleh karena itu, GRI tidak memberikan pernyataan atau jaminan tersirat maupun aktual mengenai kebenaran, kepatuhan, kepercayaan, kesesuaian tujuan atau kualitas Layanan TruCarbon atau produk apa pun yang dihasilkan darinya; atau penggunaan konten hak cipta GRI oleh TruCarbon; dan secara tegas menyangkal pernyataan tersirat atau tersurat bahwa laporan apa pun yang dihasilkan oleh TruCarbon memenuhi standar laporan standar GRI yang disetujui.
            </p>
            <p>
                <strong>TRANSAKSI </strong>
            </p>
            <ol>
                <li>
                    Pengguna wajib bertransaksi melalui prosedur transaksi yang telah ditetapkan oleh TruCarbon.
                </li>
                <li>
                    Pengguna memahami sepenuhnya dan menyetujui bahwa segala transaksi dilakukan Pengguna selain dari prosedur pemesanan yang telah ditetapkan, merupakan tanggung jawab dari Pengguna.
                </li>
                <li>
                    Pengguna disarankan untuk tetap menyimpan      seluruh bukti bayar yang dilakukan terkait dengan setiap transaksi yang berkaitan dengan Platform.
                </li>
                <li>
                    Pengguna memahami dan menyetujui bahwa masalah keterlambatan proses pembayaran dan biaya tambahan yang disebabkan karena adanya perbedaan bank yang Pengguna pergunakan dengan Bank Rekening Resmi TruCarbon adalah tanggung jawab Pengguna secara pribadi.
                </li>
            </ol>
            <p>
                <strong>PROSEDUR PEMBAYARAN</strong>
            </p>
            <ol>
                <li>
                    Segala pembayaran diadakan dalam nilai dan mata uang Rupiah.
                </li>
                <li>
                    TruCarbon dapat memungut pajak atau retribusi (apabila diperlukan atau diatur dalam peraturan perundang-undangan). Namun demikian, apabila tidak ditentukan atau diinstruksikan oleh TruCarbon, Pengguna (maupun pihak lainnya, apabila ada) akan menanggung pembayaran pajak maupun retribusinya masing-masing.
                </li>
                <li>
                    Untuk semua bentuk transaksi, Pengguna wajib melakukan pembayaran dalam batas waktu yang ditentukan. TruCarbon berhak membatalkan transaksi apabila pembayaran tidak dilakukan. Dalam hal tersebut, Pengguna tidak memiliki hak untuk mengajukan klaim apa pun.
                </li>
                <li>
                    Metode pembayaran termasuk tetapi tidak terbatas pada transfer bank, kartu kredit, dan metode pembayaran lain yang tersedia di TruCarbon (termasuk metode pembayaran dari pihak ketiga yang bekerja sama dengan TruCarbon).
                </li>
            </ol>
            <p>
                Untuk pembayaran melalui transfer bank, Pengguna wajib memberikan bukti transfer sebagai tanda pembayaran atas reservasi yang tercantum dalam email konfirmasi dari TruCarbon. Pengguna juga harus mengikuti prosedur yang tercantum dalam email konfirmasi tersebut.
            </p>
            <p>
                <strong>BIAYA LAYANAN</strong>
            </p>
            <ol>
                <li>
                    Biaya Layanan yang terdapat dalam Platform adalah harga yang ditetapkan TruCarbon dan/atau Mitra.
                </li>
                <li>
                    Pengguna memahami dan menyetujui bahwa setiap masalah dan/atau perselisihan yang terjadi akibat ketidaksepahaman antara Mitra dan Pengguna tentang harga bukanlah merupakan tanggung jawab TruCarbon.
                </li>
                <li>
                    Dengan melakukan Transaksi melalui Platform, Pengguna menyepakati untuk membayar total biaya yang harus dibayar sebagaimana tertera dalam halaman pembayaran.
                </li>
            </ol>
            <p>
                <strong>PEMBATALAN DAN PENGEMBALIAN DANA</strong>
            </p>
            <ol>
                <li>
                    Pengguna hanya dapat melakukan pembatalan atas setiap transaksi yang dilakukan dalam Platform berdasarkan diskresi dan kebijakan dari TruCarbon dan/atau Mitra.
                </li>
                <li>
                    Sehubungan dengan pembatalan pengguna yang telah dilakukan, TruCarbon mungkin dapat menahan atau mengambil bagian dari jumlah yang dibayarkan untuk mengganti biaya
                    yang telah dikeluarkan sehubungan dengan pembatalan. Pengembalian dilakukan berdasarkan kebijakan TruCarbon dan Pengguna memahami hal tersebut.
                </li>
            </ol>
            <p>
                <strong>HAK PENGGUNA</strong>
            </p>
            <p>
                TruCarbon memberi Pengguna lisensi yang bersifat pribadi, di seluruh dunia, bebas royalti, tidak dapat dialihkan, non eksklusif, dapat dibatalkan, dan tidak dapat disublisensikan untuk mengakses serta menggunakan Layanan. Lisensi ini semata-mata ditujukan agar Pengguna dapat menggunakan dan menikmati manfaat Layanan ini sebagaimana dimaksudkan oleh TruCarbon dan diizinkan oleh Ketentuan Pengguna ini. Oleh karena itu, Pengguna setuju untuk tidak:
            </p>
            <ol>
                <li>
                    menggunakan layanan atau konten apa pun yang terdapat dalam Layanan demi tujuan komersial apa pun tanpa persetujuan tertulis dari kami.
                </li>
                <li>
                    menyalin, mengubah, mengirimkan, membuat karya turunan, memanfaatkan, atau memperbanyak materi, gambar, merek dagang, nama dagang, merek layanan berhak cipta, atau kekayaan intelektual lainnya, konten, ataupun informasi paten yang dapat diakses melalui Layanan tanpa persetujuan tertulis sebelumnya dari TruCarbon.
                </li>
                <li>
                    menyatakan atau menyiratkan bahwa setiap pernyataan yang Pengguna buat didukung oleh TruCarbon.
                </li>
                <li>
                    menggunakan robot, bot (program otomatis), spider (pencari situs), crawler (perayap web), scraper (pengumpul data), aplikasi pencarian/pengambilan situs, proxy, ataupun perangkat, metode, atau proses manual maupun otomatis lainnya untuk mengakses, mengambil, mengindeks, “menambang data”, atau memperbanyak, mengakali struktur navigasi, ataupun tampilan Layanan maupun kontennya dengan cara apa pun.
                </li>
                <li>
                    menggunakan Layanan dengan cara apa pun yang dapat menghalangi, mengganggu, atau memberikan dampak negatif terhadap layanan, server, ataupun jaringan yang terhubung dengan Layanan.
                </li>
                <li>
                    mengunggah virus atau kode berbahaya lainnya ataupun membahayakan keamanan Layanan.
                </li>
                <li>
                    memalsukan atau memanipulasi pengidentifikasi guna menyamarkan asal informasi yang dikirimkan ke atau melalui Layanan.
                </li>
                <li>
                    “menjiplak” atau “meniru” bagian Layanan mana pun tanpa izin tertulis sebelumnya dari TruCarbon.
                </li>
                <li>
                    memeriksa, memindai, atau menguji kerentanan Layanan kami atau setiap sistem atau jaringan.
                </li>
                <li>
                    mendorong atau mendukung aktivitas apa pun yang melanggar Ketentuan Pengguna ini.
                </li>
            </ol>
            <p>
                <strong>HAK ATAS KEKAYAAN INTELEKTUAL</strong>
            </p>
            <ol>
                <li>
                    Kami merupakan pemegang lisensi dan/atau hak atas nama, ikon, logo, dan merek dagang ‘
                    <strong>TRUCARBON’</strong>
                    , ‘
                    <strong>TRUCOUNT’</strong>
                    , serta merek, platform, atau identitas lainnya yang dikembangkan atau dioperasikan di bawah TruCarbon, yang dilindungi oleh hukum kekayaan intelektual yang berlaku di Republik Indonesia. Pengguna tidak diperkenankan untuk menggunakan, menggandakan, memodifikasi, atau menginstal sebagian atau seluruh nama, ikon, logo, atau merek tersebut tanpa persetujuan tertulis dari kami.
                </li>
                <li>
                    Kami berhak untuk mengambil tindakan hukum atas setiap pelanggaran yang dilakukan oleh Pengguna atau pihak ketiga terhadap hak kekayaan intelektual kami yang berkaitan dengan Aplikasi, Platform (TruCount), maupun layanan dan/atau merek lain yang dikembangkan atau terafiliasi dengan TruCarbon.
                </li>
            </ol>
            <p>
                <strong>KETENTUAN LAIN-LAIN</strong>
            </p>
            <ol>
                <li>
                    Apabila Pengguna mempergunakan fitur-fitur yang tersedia dalam Platform, maka Pengguna dengan ini menyatakan memahami dan menyetujui segala syarat dan ketentuan yang diatur khusus.
                </li>
                <li>
                    Segala hal yang belum dan/atau tidak diatur dalam Ketentuan Pengguna maka akan sepenuhnya merujuk pada Ketentuan Pengguna secara umum.
                </li>
            </ol>
            <p>
                <strong>PERNYATAAN DAN JAMINAN PENGGUNGA</strong>
            </p>
            <p>
                Pengguna menyatakan dan menjamin kepada TruCarbon bahwa pihaknya (i) cakap secara hukum untuk mengikatkan diri dalam Perjanjian dan menggunakan Platform; (ii) telah memperoleh persetujuan (baik internal maupun eksternal) untuk mengikatkan diri dalam Perjanjian dan menggunakan Platform (apabila ada); dan (iii) tidak dilarang ataupun bertentangan dengan perjanjian lain dari Pengguna dengan pihak lainnya.
            </p>
            <p>
                <strong>PENOLAKAN JAMINAN DAN BATASAN TANGGUNG JAWAB</strong>
            </p>
            <ol>
                <li>
                    TruCarbon selalu berupaya untuk menjaga layanan Platform aman, nyaman, dan berfungsi dengan baik, tapi kami tidak dapat menjamin operasi terus menerus atau akses layanan kami selalu sempurna. Informasi dan data dalam Platform memiliki kemungkinan tidak terjadi secara real time.
                </li>
                <li>
                    Pengguna setuju bahwa Pengguna memanfaatkan layanan TruCarbon atas segala risiko Pengguna dan layanan TruCarbon diberikan kepada Pengguna berdasarkan pada kondisi “sebagai mana adanya” dan “sebagaimana tersedia”.
                </li>
                <li>
                    Sejauh diizinkan oleh hukum yang berlaku, TruCarbon tidak bertanggung jawab dan Pengguna setuju untuk tidak menuntut TruCarbon atas segala kerusakan atau kerugian yang diakibatkan secara langsung atau tidak langsung dari:
                </li>
                <li>
                    Penggunaan atau ketidakmampuan Pengguna menggunakan Layanan.
                </li>
                <li>
                    Harga, pengiriman atau petunjuk lain yang tersedia dalam Layanan.
                </li>
                <li>
                    Keterlambatan atau gangguan dalam Layanan.
                </li>
                <li>
                    Kelalaian yang diakibatkan oleh Pengguna.
                </li>
                <li>
                    Perselisihan antar Pengguna.
                </li>
                <li>
                    Pelanggaran Hak atas Kekayaan Intelektual.
                </li>
                <li>
                    Pencemaran nama baik.
                </li>
                <li>
                    Kerugian akibat pembayaran di luar metode yang ditetapkan oleh TruCarbon.
                </li>
                <li>
                    Virus atau perangkat lunak berbahaya lainnya yang diperoleh dengan mengakses atau menghubungkan ke Layanan.
                </li>
                <li>
                    Gangguan, bug, kesalahan maupun ketidakakuratan apa pun dalam Layanan.
                </li>
                <li>
                    Adanya tindakan peretasan yang dilakukan oleh pihak ketiga kepada akun Pengguna.
                </li>
            </ol>
            <p>
                <strong>GANTI RUGI</strong>
            </p>
            <p>
                Pengguna wajib mengganti kerugian dan membebaskan TruCarbon dari segala klaim dan tuntutan, termasuk biaya hukum yang wajar, yang diajukan oleh pihak ketiga yang timbul dari pelanggaran ketentuan dalam Ketentuan Pengguna ini atau penggunaan layanan TruCarbon secara tidak semestinya.
            </p>
            <p>
                <strong>KETERPISAHAN</strong>
            </p>
            <p>
                Masing-masing ketentuan dalam Ketentuan Pengguna ini dapat dipisahkan dari yang lainnya, dan jika terdapat ketentuan yang dianggap tidak sah atau tidak dapat dilaksanakan, ketentuan lainnya
                akan tetap berlaku dan memiliki kekuatan hukum penuh. TruCarbon berhak untuk mengubah setiap ketentuan apa pun dari Ketentuan Pengguna ini yang melanggar atau bertentangan dengan peraturan perundang-undangan (baik yang telah ada maupun akan datang) untuk menyesuaikannya dengan peraturan perundang-undangan tersebut, tanpa menghilangkan keabsahan dari Ketentuan Pengguna ini.
            </p>
            <p>
                <strong>PEMBAHARUAN</strong>
            </p>
            <p>
                Ketentuan Pengguna ini mungkin diubah dan/atau diperbaharui dari waktu ke waktu tanpa pemberitahuan sebelumnya. TruCarbon menyarankan agar Pengguna membaca secara seksama dan memeriksa halaman Ketentuan Pengguna ini dari waktu ke waktu untuk mengetahui perubahan apapun. Dengan tetap mengakses layanan TruCarbon, maka pengguna dianggap menyetujui perubahan dalam Ketentuan Pengguna.
            </p>
            <p>
                <strong>PILIHAN HUKUM DAN PENYELESAIAN SENGKETA</strong>
            </p>
            <p>
                Ketentuan Pengguna ini diatur dan dibuat berdasarkan hukum di Republik Indonesia. Pengguna setuju bahwa apabila timbul sengketa atas Ketentuan Pengguna ini maupun akibat dari layanan kami, maka penyelesaian sengketa dilakukan secara musyawarah mufakat. Apabila tidak dapat diselesaikan, sengketa dapat diselesaikan melalui Badan Arbitrase Nasional Indonesia (BANI) dengan alamat terdaftar di Wahana Graha Lt. 1 &amp; 2, Jalan Mampang Prapatan No. 2, Duren Tiga, Pancoran, RT.4 / RW.1, Duren Tiga, Kec. Pancoran, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12760; sesuai dengan ketentuan yang berlaku mengenai penyelesaian sengketa melalui arbitrase di Indonesia.
            </p>
            <p>
                <strong>KEADAAN KAHAR</strong>
            </p>
            <p>
                TruCarbon tidak bertanggung jawab atas pelanggaran yang terjadi terhadap perjanjian ini terkait kerusakan sistem yang di luar dugaan. Keadaan kahar termasuk namun tidak terbatas pada bencana alam (banjir, gempa bumi, kebakaran), terorisme, pandemi, epidemi, embargo, pergantian peraturan perundang-undangan, dan serangan siber.
            </p>
            <p>
                <strong>KESELURUHAN PERJANJIAN</strong>
            </p>
            <p>
                Ketentuan Pengguna ini merupakan keseluruhan perjanjian antara Pengguna dan TruCarbon sehubungan dengan pokok bahasan Ketentuan Pengguna ini. Semua perjanjian atau pengaturan sebelumnya, tertulis atau lisan, antara Pengguna dan TruCarbon yang berkaitan dengan materi pelajaran dengan ini digantikan oleh Ketentuan Pengguna ini.
            </p>
            <p>
                <strong>UMUM</strong>
            </p>
            <ol>
                <li>
                    Ketentuan Pengguna ini akan mengatur seluruh perjanjian dan pemahaman antara Pengguna dan TruCarbon pada pokok dari padanya, dan akan menggantikan semua perjanjian sebelumnya, baik tertulis atau lisan, antara Pengguna dan TruCarbon tentang pokok dari padanya. Apabila diperlukan, TruCarbon dan Pengguna (serta pihak lainnya, apabila relevan) dapat menandatangani perjanjian terpisah lainnya sebagai implementasi dari pemberian Layanan kepada Pengguna.
                </li>
                <li>
                    TruCarbon dan Pengguna (serta pihak lainnya, apabila ada) setuju untuk mengesampingkan ketentuan Pasal 1266 dan 1267 Kitab Undang -Undang Hukum Perdata sejauh Pasal tersebut memerlukan persetujuan pengadilan untuk pengakhiran Ketentuan Pengguna.
                </li>
                <li>
                    Untuk menghindari keraguan, TruCarbon tidak mengelola atau mengontrol Mitra.
                </li>
                <li>
                    Ketentuan Pengguna ini dibuat dalam Bahasa Indonesia dan Bahasa Inggris dan telah sesuai dengan ketentuan perundang-undangan mengenai penggunaan Bahasa Indonesia. Dalam hal terdapat perbedaan terjemahan, maka versi Bahasa Indonesia akan berlaku, dan versi Bahasa Inggris wajib disesuaikan dengan versi Bahasa Indonesia. Lebih lanjut, Pengguna juga menyetujui bahwa tidak akan mengajukan klaim atau gugatan apa pun kepada TruCarbon terkait dengan penggunaan bahasa dalam Ketentuan Pengguna ini.
                </li>
                <li>
                    Dalam hal bahwa ketentuan apa pun ditetapkan untuk tidak dapat dilaksanakan atau tidak sah, oleh pengadilan dari yurisdiksi yang kompeten, maka ketentuan tersebut akan tetap diberlakukan sejauh diizinkan oleh hukum yang berlaku dan ketetapan tersebut tidak akan mempengaruhi validitas dan keberlakuan dari setiap ketentuan lainnya yang tersisa. Ketentuan yang terputus harus digantikan dengan ketentuan yang mendekati kata-kata asli dan maksud sebanyak mungkin.
                </li>
                <li>
                    Kegagalan salah satu Pihak untuk melaksanakan setiap ketentuan dari Syarat ini kapan saja tidak akan ditafsirkan sebagai pelepasan hak masing-masing Pihak untuk melaksanakan pelanggaran ketentuan tersebut atau setiap ketentuan lainnya dalam Syarat ini atau sebagai pelepasan dari pelanggaran yang terus-menerus, yang berikut atau yang menyusul atas setiap ketentuan atau ketentuan lainnya dari Ketentuan Pengguna ini.
                </li>
                <li>
                    Pengguna tidak boleh mengalihkan atau memindahtangankan hak atau kewajibannya berdasarkan Ketentuan ini tanpa persetujuan tertulis sebelumnya dari TruCarbon.
                </li>
                <li>
                    Ketentuan Pengguna ini dan Kebijakan Privasi (
                    <a href="https://account.trucarbon.co/assets/documents/privacy-policy.pdf" target="_blank" rel="noreferrer">
                        terdapat di sini
                    </a>
                    ) merupakan satu kesatuan yang harus disetujui bersama oleh Pengguna sebelum penggunaan Platform.
                </li>
            </ol>
            <p>
                <strong>FAQs</strong>
            </p>
            <p>
                Jika Anda memiliki pertanyaan lebih lanjut, harap merujuk pada{" "}
                <a href="https://trucarbon.co/contact-us" target="_blank" rel="noreferrer">
                    FAQs
                </a>
                .
            </p>
            <p>
                Atau dapat melalui email kami di:{" "}
                <a href="mailto:contact@trucarbon.co" target="_blank" rel="noreferrer">
                    contact@trucarbon.co
                </a>
            </p>
        </div>
    );
}
